import React from "react"

class AddressBook extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addresses: this.props.addresses
    };

    this.setDeliveryAddress = this.setDeliveryAddress.bind(this);
    this.filterAddressesByPostCode = this.filterAddressesByPostCode.bind(this);
  }
  componentWillReceiveProps(props) {
    this.setState({ addresses: props.addresses });
  }
  filterAddressesByPostCode(e) {
    var filter_value = e.target.value;
    if (filter_value) {
      var filteredAddresses = _.filter(this.props.addresses, address => {
        if (
          _.includes(
            address.postcode.toUpperCase(),
            filter_value.toUpperCase()
          ) ||
          _.includes(
            address.line_1.toUpperCase(),
            filter_value.toUpperCase()
          ) ||
          _.includes(address.name.toUpperCase(), filter_value.toUpperCase())
        ) {
          return address;
        }
      });
      this.setState({
        addresses: filteredAddresses
      });
    } else {
      this.setState({
        addresses: this.props.addresses
      });
    }
  }
  setDeliveryAddress(address) {
    if (this.props.current_step === "PAYMENT")
      if (this.props.disableClick === true) return false;
    if (this.props.handleGuestBillingAddress) {
      this.props.handleGuestBillingAddress(address);
    } else {
      this.props.setAddressFromAddressBook(address);
    }
  }

  render() {
    var addresses =
      this.state.addresses.length > 0
        ? this.state.addresses.map((address, index) => {
            var selected =
              _.isEqual(
                {
                  delivery_address1: address.line_1,
                  delivery_address2: address.line_2,
                  delivery_address3: address.line_3,
                  delivery_address4: address.line_4,
                  delivery_address5: address.line_5,
                  delivery_postcode: address.postcode,
                  delivery_name: address.name
                },
                this.props.selectedDeliveryAddress
              ) === true
                ? "selected"
                : "";
            return (
              <div
                className={"address-book-address " + selected}
                key={index}
                onClick={this.setDeliveryAddress.bind(this, address)}
              >
                <ul key={index}>
                  <li className="address-name">
                    <strong>{address.name}</strong>
                  </li>
                  <li>{address.line_1}</li>
                  <li>{address.line_2}</li>
                  <li>{address.line_3}</li>
                  <li>{address.postcode}</li>
                </ul>
                <div className="actions">
                  {selected ? (
                    <div>
                      <span className="selected-icon" /> Selected
                    </div>
                  ) : (
                    <div>
                      <span className="selected-icon" /> Select
                    </div>
                  )}
                </div>
              </div>
            );
          })
        : "No Addresses Found";
    return (
      <div
        className={
          "checkout-sub-panel " +
          (this.props.addressMode === "ADDRESS_BOOK" ? "" : "hide")
        }
      >
        <div className="fl-on fl-jc-sb">
          <div>
            {this.props.current_step === "PAYMENT" &&
            this.props.addressMode === "BRANCH_DELIVERY" ? (
              <h2>Select Billing Address</h2>
            ) : (
              <h2>Choose from your Address Book</h2>
            )}
          </div>
        </div>
        <div className="fl-on fl-jc-sb">
          <div className="fl-fb-50">
            <input
              type="text"
              placeholder="Search Address Book by Postcode"
              onChange={this.filterAddressesByPostCode}
              className="search-addresses"
              autoComplete="no"
            />
          </div>
        </div>

        <div className="address-book">{addresses}</div>
      </div>
    );
  }
}

export default AddressBook;
